import {
  PICKLEBALL_CENTRAL_LOGO,
  PICKLEBALL_CENTRAL_URL,
} from '@/modules/players/v3/constants/constants';

interface PickleballCentralLogoProps {
  width?: number;
  height?: number;
  clickable?: boolean;
}

export const PickleballCentralLogo = ({
  width = 120,
  height = 35,
  clickable = true,
}: PickleballCentralLogoProps) => {
  const logo = (
    <img src={PICKLEBALL_CENTRAL_LOGO} alt='Pickleball Central' width={width} height={height} />
  );

  if (!clickable) {
    return logo;
  }

  return (
    <a
      href={PICKLEBALL_CENTRAL_URL}
      target='_blank'
      rel='noopener noreferrer'
      aria-label='Link to Pickleball Central (opens in a new tab)'
    >
      {logo}
    </a>
  );
};
